import { EventClaim } from "../../types/eventClaim.types";
import { ApiResponseType, makeRequest } from "../helpers/api.helpers";
import { createDebounce } from "../helpers/debounce.helper";
import { getCompanyId } from "./company.api";

const API_URL = import.meta.env.VITE_API_URL;

const makeRequestDebounced = createDebounce(makeRequest, 200);

type GetPagedEventClaimOptions = {
  status?: string[];
  search?: string;
  startDate?: string;
  endDate?: string;
  startDateAtualizadoEm?: string;
  endDateAtualizadoEm?: string;
  page?: number;
  itemsPerPage?: number;
  orderBy?: string;
  technicalConsultant?: string;
  includeDeleted?: boolean;
  fields?: string;
};

export async function getPagedEventClaim(
  options: GetPagedEventClaimOptions = {}
) {
  const {
    status = [],
    search = "",
    startDate = "",
    endDate = "",
    startDateAtualizadoEm = "",
    endDateAtualizadoEm = "",
    page = 1,
    itemsPerPage = 10,
    orderBy = "",
    technicalConsultant = "",
    includeDeleted = false,
    fields = "eventType, eventDate, location, state, city, licensePlate, associateName, vehicleType, phone, whatsapp, email, reportText, status, associatedTrigger, thirdPartiesInvolved, thirdPartiesCount, documents.type, documents.content, documents.verified, thirdParties.name, thirdParties.licensePlate, thirdParties.phone, thirdParties.eventThirdPartyType, createdAt, updatedAt, deleteAt",
  } = options;
  const params = new URLSearchParams({
    page: String(page),
    itemsPerPage: String(itemsPerPage),
    fields,
  });

  let statusParam = "";
  if (Array.isArray(status) && status.length > 0) {
    statusParam = status.join(",");
  } else if (typeof status === "string") {
    statusParam = status;
  }

  status && params.append("filters[status]", statusParam);
  search && params.append("search", search);
  orderBy && params.append("orderBy", orderBy);
  startDate && params.append("filters[startDate]", startDate.toString());
  endDate && params.append("filters[endDate]", endDate.toString());
  startDateAtualizadoEm &&
    params.append(
      "filters[startDateAtualizadoEm]",
      startDateAtualizadoEm.toString()
    );
  endDateAtualizadoEm &&
    params.append(
      "filters[endDateAtualizadoEm]",
      endDateAtualizadoEm.toString()
    );
  technicalConsultant &&
    params.append("filters[technicalConsultant]", technicalConsultant);

  if (!includeDeleted) params.append("filters[deleteAt]", "null"); // Filtra apenas registros onde deleteAt é null

  const url = `${API_URL}/event-claim?${params.toString()}`;
  return (await makeRequestDebounced(url)) as ApiResponseType<EventClaim[]> & {
    totalItems: number;
    itemsPerPage: number;
  };
}

export async function createEventCliam(createData: EventClaim) {
  createData.companyId = getCompanyId();

  const url = `${API_URL}/event-claim`;
  const options = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(createData),
  };
  return makeRequestDebounced(url, options) as Promise<
    ApiResponseType<EventClaim>
  >;
}

export async function updateEventClaim(
  updatedData: Partial<EventClaim>
): Promise<ApiResponseType<EventClaim>> {
  const url = `${API_URL}/event-claim`;
  const options = {
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(updatedData),
  };

  return makeRequestDebounced(url, options) as Promise<
    ApiResponseType<EventClaim>
  >;
}

export async function deleteEventClaim(eventClaimId: string) {
  const url = `${API_URL}/event-claim/${eventClaimId}`;
  const options = {
    method: "DELETE",
    headers: { "Content-Type": "application/json" },
  };

  return makeRequestDebounced(url, options) as Promise<
    ApiResponseType<EventClaim>
  >;
}
